module.exports = __webpack_public_path__ + "static/img/title_1.3982c15f.jpg";